export const SCN_OPCODE_ADD_HUB_OBJECT = 1;
export const SCN_OPCODE_DELETE_HUB_OBJECT = 2;
export const SCN_OPCODE_DELETE_HUB_OBJECTS = 3;
export const SCN_OPCODE_MOVE_HUB_OBJECTS = 301;
export const SCN_OPCODE_UPDATE_HUB_OBJECT = 302;
export const SCN_UPDATE_HUB_OBJECT = 302;
export const SCN_OPCODE_UPDATE_USER = 401;
export const SCN_OPCODE_STORY_LOCK_ACQUIRED = 10;
export const SCN_OPCODE_STORY_LOCK_RELEASED = 11;

